import React, { useEffect, useState } from 'react';
import { TextField } from '@material-ui/core';
import ButtonSmall from 'components/common/Buttons/ButtonSmall';
import {
  sessionSet,
  sessionGet,
  sessionClear,
  SessionKeys,
} from 'utils/tokenStorage';
import Select from 'components/common/Select';
import { programOptions } from './utils';
import { IFormData, IFormProps } from './types';
import styles from './styles.module.scss';
import { ProgramEnum } from '../../types/general';

export const LoginForm = (props: IFormProps) => {
  let initialState = {
    identifier: '',
    password: '',
    patientId: '',
    program: ProgramEnum.RESET_O,
  };

  const [formData, setFormData] = useState<IFormData>(
    sessionGet(SessionKeys.SIMULATOR_STATE)?.length
      ? JSON.parse(sessionGet(SessionKeys.SIMULATOR_STATE) ?? '')
      : initialState,
  );

  const [hasEmptyField, setHasEmptyField] = useState(true);

  const handleInputChange = (event: any) => {
    const {
      target: { name, value },
    } = event;
    const cleanInput = { ...formData, [name]: value.trim() };
    setFormData(cleanInput);
  };

  const handleSubmit = () => {
    sessionSet(SessionKeys.SIMULATOR_STATE, JSON.stringify(formData));
    props.handleSubmit(formData);
  };

  const handleSelect = (option: IOptionType) => {
    setFormData({ ...formData, program: option.value });
  };

  const resetForm = () => {
    setFormData(initialState);
    sessionClear(SessionKeys.SIMULATOR_STATE);
  };

  useEffect(() => {
    const anyEmptyFields = Object.values(formData).some(
      (i) => i === null || i === '',
    );
    setHasEmptyField(anyEmptyFields);
  }, [formData]);

  return (
    <>
      <form className={styles.inputs}>
        <div>
          <TextField
            data-testid="input-identifier"
            autoFocus
            className={styles.identifier}
            fullWidth
            helperText={'Username or email'}
            id="identifier"
            name="identifier"
            onChange={(e) => handleInputChange(e)}
            placeholder="Enter username or email"
            required
            type="identifier"
            value={formData.identifier}
            variant="outlined"
          />
        </div>
        <div>
          <TextField
            data-testid="input-password"
            className={styles.password}
            fullWidth
            helperText={'password'}
            id="password"
            name="password"
            onChange={(e) => handleInputChange(e)}
            placeholder="Enter Password"
            required
            type="password"
            value={formData.password}
            variant="outlined"
          />
        </div>
        <div id="patientid">
          <TextField
            data-testid="input-patient-id"
            className={styles.patientid}
            fullWidth
            helperText={'Patient ID'}
            id="patientId"
            name="patientId"
            onChange={(e) => handleInputChange(e)}
            placeholder="Enter Patient ID"
            required
            value={formData.patientId}
            variant="outlined"
          />
        </div>

        <div className={styles.prog}>
          <Select
            name="program"
            disableSorting
            options={programOptions}
            selectedOption={programOptions.find(
              (option) => option.value === formData.program,
            )}
            onChange={handleSelect}
          />
        </div>
        <div
          data-testid="button-simulation"
          className={`${styles.submit} ${styles.button}`}
        >
          <ButtonSmall
            buttonRole="secondary"
            disabled={hasEmptyField}
            handleClick={handleSubmit}
            height={'inherit'}
            width={'inherit'}
          >
            <span className={styles.text}>Run Simulation</span>
          </ButtonSmall>
        </div>

        <div
          data-testid="button-reset"
          className={`${styles.wipe} ${styles.button}`}
        >
          <ButtonSmall
            buttonRole="dashboard"
            handleClick={resetForm}
            height={'inherit'}
            width={'inherit'}
          >
            <span className={styles.text}>Reset Form</span>
          </ButtonSmall>
        </div>
      </form>
    </>
  );
};
